export default __webpack_public_path__ + "static/media/image.pentool-design-print.d4a70623.png";